import { Button } from '../../../../../../../core/components/atoms/Button';
import InnerHTMLContainer from '../../../../../../../core/components/molecules/InnerHTMLContainer';
import { Typography } from '../../../../../../../core/components/molecules/Typography';
import { useEssayScheduleStore } from '../../../../../stores/essayScheduleStore';

interface IScheduleEssayTheme {
  onStart: () => void;
  loading: boolean;
}

const ScheduleEssayTheme: React.FC<IScheduleEssayTheme> = ({ onStart, loading }) => {
  const { essaySchedule } = useEssayScheduleStore();

  if (!essaySchedule) {
    return (
      <Typography className='text-center'>
        Não foi encontrado um tema para a redação
      </Typography>
    );
  }

  const removeAlign = (html?: string) => {
    if (html) {
      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*(left|right|justify)[^'"]*['"]?[^>]*>/gi,
        '<p style="text-align: center">'
      );

      html = html.replace(
        /<h1[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*(left|right|justify)[^'"]*['"]?[^>]*>/gi,
        '<h1 style="text-align: center">'
      );

      html = html.replace(
        /<h2[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*(left|right|justify)[^'"]*['"]?[^>]*>/gi,
        '<h2 style="text-align: center">'
      );

      return html;
    }

    return '';
  };

  const handlePrint = () => {
    window.open(
      'https://storage.aprovatotal.com.br/admin-storage-prod/folhas/GENEROS_TEXTUAIS.pdf'
    );
  };
  const isEssayDone = essaySchedule.done;
  return (
    <div className='flex flex-col gap-xl p-8'>
      <Typography type='title' weight='bold' className='text-center'>
        {essaySchedule.title}
      </Typography>
      <div className='flex flex-col gap-lg'>
        <div>
          <InnerHTMLContainer
            type='theme'
            align='center'
            font='noto'
            data={removeAlign(essaySchedule.description) || ''}
            className='flex-col items-center text-center text-mono-color-darkest [&>*]:text-center'
          />
        </div>
        <div className='mb-20'>
          <InnerHTMLContainer
            type='theme'
            align='center'
            font='noto'
            data={removeAlign(essaySchedule.motivationalText) || ''}
            className='flex-col items-center text-center text-mono-color-darkest [&>*]:text-center'
          />
        </div>
      </div>
      <div className='flex w-full flex-col items-center justify-between gap-lg md:flex-row'>
        <Button
          LeftIcon='open_in_new'
          size='small'
          variant='text'
          onClick={() => handlePrint()}
          iconSize='small'
          className='xs:hidden md:flex'
        >
          Imprimir folha de redação
        </Button>
        <Button
          LeftIcon='open_in_new'
          size='small'
          variant='text'
          onClick={() => handlePrint()}
          iconSize='small'
          className='xs:flex md:hidden'
        >
          Folha de redação
        </Button>
        <div className='w-[70%]'>
          <Button
            LeftIcon='edit'
            size='regular'
            variant='contained'
            onClick={() => {
              if (!isEssayDone) onStart();
            }}
            classNameIcon='xs:hidden lg:flex'
            loading={loading}
            disabled={isEssayDone}
            full
          >
            {isEssayDone ? 'Esta redação já foi enviada para correção' : 'Escrever redação'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleEssayTheme;
